import { render, staticRenderFns } from "./MChat.vue?vue&type=template&id=d9f73f22&scoped=true"
import script from "./MChat.vue?vue&type=script&lang=js"
export * from "./MChat.vue?vue&type=script&lang=js"
import style0 from "./MChat.vue?vue&type=style&index=0&id=d9f73f22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f73f22",
  null
  
)

export default component.exports